import { PREFIX_PRODUCER } from "@/api/Model/ProductOwnerModel";
import CommercialProductIpr from "./CommercialProductIpr";

class Producer extends CommercialProductIpr {
  static getResourceEndpoint() {
    return PREFIX_PRODUCER + '/commercial-products-ipr';
  }
}

export default Producer;
